/** @format */

export const $_display = {
	/**
	 * @public
	 * @description
	 * Here we will update the instance.display object which handles the
	 * year and month we are currently viewing in the calendar.
	 *
	 * @param {Object} date destructed 'date' from our current record
	 * @param {Object} instance active datepicker instance
	 */
	updateCalendarViewFromDate({ date }, instance) {
		instance.display.monthIndex = date.monthInt - 1; //starts at key 0 for Jan
		instance.display.monthIntAsString = date.monthIntAsString;
		instance.display.monthNameByLocale = date.monthLong;
		instance.display.year = date.year;
		instance.display.yearByLocale = date.yearByLocale;
		return instance;
	}
};

export { $_display as default };
